import { useMutation } from '@apollo/client'
import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography
} from '@material-ui/core'
import { toast } from 'react-toastify'

import {
  ADD_ADDON_TO_CART_MUTATION,
  REMOVE_ADDON_FROM_CART_MUTATION
} from '../../../../graphql/cartCrud'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { ItemAddOn } from '../../../../types/cart'
import useStyles from './styles/index.styles'

type Props = {
  data: ItemAddOn
  cartID: String
  itemID: string
  handleRefetch: () => Promise<void>

  selectedAddOns: string[] | undefined
  setSelectedAddOns: React.Dispatch<React.SetStateAction<string[]>>
}
const AddOnRow = ({
  data,
  cartID,
  itemID,

  handleRefetch,
  selectedAddOns,
  setSelectedAddOns
}: Props) => {
  const classes = useStyles()

  const [addAddOn, { loading: loadingForAdd }] = useMutation(
    ADD_ADDON_TO_CART_MUTATION,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (res) => {
        toast.success(res.message)
        handleRefetch()
      },
      onError: (err) => {
        toast.error(err.message)
      }
    }
  )
  const [removeAddOn, { loading: loadingForRemove }] = useMutation(
    REMOVE_ADDON_FROM_CART_MUTATION,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (res) => {
        toast.success(res.message)
        handleRefetch()
      },
      onError: (err) => {
        toast.error(err.message)
      }
    }
  )

  return (
    <div className={classes.root}>
      <div className={classes.left}>
        <Typography variant="h5" className={classes.text}>
          {data.name}
        </Typography>
      </div>
      <div className={classes.middle}>
        <FormControlLabel
          className={classes.formcontrol}
          label={getTranslate('')}
          control={
            loadingForRemove || loadingForAdd ? (
              <CircularProgress size={12} />
            ) : (
              <Checkbox
                onChange={(event) => {
                  if (event.currentTarget.checked) {
                    setSelectedAddOns((prev) => [...prev, data.code])
                    addAddOn({
                      variables: {
                        input: { cartID, itemID, addOnCode: data.code }
                      }
                    })
                  } else {
                    setSelectedAddOns((prev) =>
                      prev.filter((code) => code !== data.code)
                    )
                    removeAddOn({
                      variables: {
                        input: { cartID, itemID, addOnCode: data.code }
                      }
                    })
                  }
                }}
                color="primary"
                size="small"
                style={{ padding: 0, marginRight: 4 }}
                checked={selectedAddOns?.includes(data.code)}
              />
            )
          }
        />
      </div>
      <div className={classes.right}>
        {/* Strictly-above, not `!==`: an add-on whose price ROSE would
            otherwise strike the lower "before" figure beside the higher charged
            one, presenting an increase as a discount (same defect class as
            ADR-040 §2.5, on the booking path). */}
        {data.priceBeforeDiscount > data.priceAfterDiscount ? (
          <>
            <Typography variant="h6" className={classes.discountText}>
              {`${addCommaToPrice(data.priceBeforeDiscount)}`}
            </Typography>
            <Typography variant="h6" className={classes.text}>
              {`${addCommaToPrice(data.priceAfterDiscount)}  ${getTranslate(
                data.currency || ''
              )}`}
            </Typography>
          </>
        ) : (
          <Typography variant="h6" className={classes.text}>
            {`${addCommaToPrice(data.priceAfterDiscount)}  ${getTranslate(
              data.currency || ''
            )}`}
          </Typography>
        )}
      </div>
    </div>
  )
}

export default AddOnRow
